export class ResponseHelper {
    static throwIfOnError(response: Response) {
        switch (response.status) {
            case 400:
                throw new Error(
                    "Error on '" +
                        response.url +
                        "' (400 Bad request) - Message: '" +
                        response.statusText +
                        "'"
                );

            case 401:
                throw new Error(
                    "Error on '" +
                        response.url +
                        "' (401 UnAuthorized) - Message: '" +
                        response.statusText +
                        "'"
                );

            case 403:
                throw new Error(
                    "Error on '" +
                        response.url +
                        "' (403 UnAuthorized) - Message: '" +
                        response.statusText +
                        "'"
                );

            case 500:
                throw new Error(
                    "Error on '" + response.url + "' service unavailable"
                );
        }
    }
}
